import React from 'react';
import Grid, { GridProps } from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) =>
  ({
    root: {
      [theme.breakpoints.down('md')]: {
        order: -1,
      },
      paddingRight: theme.spacing(2),
    },
  })
);

export function AreaRightSide<C extends React.ElementType>(props: GridProps<C, { component?: C }>) {
  const { classes } = useStyles();
  const defaults = {
    item: true,
    xs: 12,
    md: 4,
    lg: 3,
  };
  const newProps = { ...defaults, ...props };

  return <Grid className={classes.root} {...newProps} />;
}
